export default "__VITE_PUBLIC_ASSET__fe6b24df__"